<template>
  <div class="live-commerce">
    <!-- 系统功能 -->
    <div class="industry">
      <div class="industry-title">系统功能</div>
      <div class="industry-line"></div>
      <div class="industry-text">满足不同商家角色对功能的需求</div>
      <div class="industry-box">
        <div class="industry-box-left">
          <div class="industry-box-left-public">
            <img
              src="../../static/images/zhibodadan.png"
              alt=""
              class="public-img"
            />
            <div>
              <div class="public-title">直播打单</div>
              <div class="public-text">
                急一单一货一件 /一单一货多件 /购物车订单/实现批量拣货、快速发货。
              </div>
            </div>
          </div>
          <div class="industry-box-left-public">
            <img
              src="../../static/images/siyuxuanpin.png"
              alt=""
              class="public-img"
            />
            <div>
              <div class="public-title">私域选品</div>
              <div class="public-text">
                供应商上架、渠道商铺货，提高已合作商家之间商品协同效率。
              </div>
            </div>
          </div>
          <div class="industry-box-left-public">
            <img
              src="../../static/images/dingdanfenfa.png"
              alt=""
              class="public-img"
            />
            <div>
              <div class="public-title">订单分发</div>
              <div class="public-text">
                在线邀请供应商，订单自动分发到自有仓库和供应商，物流信息自动回传。
              </div>
            </div>
          </div>
        </div>
        <div class="industry-box-right">
          <div class="industry-box-left-public">
            <img
              src="../../static/images/kucunguanli.png"
              alt=""
              class="public-img"
            />
            <div>
              <div class="public-title">库存管理</div>
              <div class="public-text">
                布局线上线下，形成互补运营方式，大程度提高顾客的消费体验性。
              </div>
            </div>
          </div>
          <div class="industry-box-left-public">
            <img
              src="../../static/images/shangpinguanli.png"
              alt=""
              class="public-img"
            />
            <div>
              <div class="public-title">商品管理</div>
              <div class="public-text">
                一键铺货解放双手，告别手动上架1分钟完成所有店铺铺货。
              </div>
            </div>
          </div>
          <div class="industry-box-left-public">
            <img
              src="../../static/images/caiwuduizhang.png"
              alt=""
              class="public-img"
            />
            <div>
              <div class="public-title">财务对账</div>
              <div class="public-text">
                解决顾客维护 多边财务对账，自定义账期，一键出账。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 核心价值 -->
    <div class="wholesale-mall-core">
      <div class="core-title">核心价值</div>
      <div class="core-line"></div>
      <div class="core-text">借助有效资源，提高商品交易转化率</div>
      <div class="core-box">
        <div class="supply">
          <div class="supply-top">
            <img
              src="../../static/images/dichengben.png"
              alt=""
              class="supply-img"
            />
          </div>
          <div class="supply-title">低成本更便捷的直播互动</div>
          <div class="supply-text">
            云销城突破商品纯图片展示的局限，满足商家视频直播卖货，增加与消费者更多互动。
          </div>
        </div>
        <div class="supply">
          <div class="supply-top">
            <img
              src="../../static/images/yidongduan.png"
              alt=""
              class="supply-img"
            />
          </div>
          <div class="supply-title">借助移动端玩转直播</div>
          <div class="supply-text">
            支持在移动端H5、APP上玩转直播，吸引更多用户，引爆平台超高人气流量(产)。
          </div>
        </div>
        <div class="supply">
          <div class="supply-top">
            <img
              src="../../static/images/renqizhubo.png"
              alt=""
              class="supply-img"
            />
          </div>
          <div class="supply-title">吸引更多人气主播</div>
          <div class="supply-text">
            平台可以招募更多人气主播来提升商品的知名度，让平台拥有更广泛的业务区域。
          </div>
        </div>
        <div class="supply">
          <div class="supply-top">
            <img
              src="../../static/images/xiaofeizhuanhua.png"
              alt=""
              class="supply-img"
            />
          </div>
          <div class="supply-title">消费转化逐步提升</div>
          <div class="supply-text">
            利用直播、短视频的红利时期，有效提升平台的购物消费体验，提高商品交易的转化率。
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="application-scenarios">
      <div class="core-title">应用场景</div>
      <div class="core-line"></div>
      <div class="core-text">适用于户外，平台商品展示，新品发布，网红直播</div>
      <div class="scenarios-tab">
        <div @click="active(1)" :class="{current:num == 1}">户外直播导购</div>
        <div @click="active(2)" :class="{current:num == 2}">平台商品展示</div>
        <div @click="active(3)" :class="{current:num == 3}">新品发布直播</div>
        <div @click="active(4)" :class="{current:num == 4}">网红主播开店</div>
      </div>
      <div v-if="num == 1" class="scenarios-box">
        <div class="scenarios-box-left">
          <div class="scenarios-box-title">户外直播导购</div>
          <div class="scenarios-box-line"></div>
          <div class="scenarios-box-text">在原有电商平台上加入视频直播入口，全方位展示商品细节信息、商品使用流程，在线解答用户关于商品的所有疑问，促进商品销售。</div>
          <div class="scenarios-box-btn">立即体验</div>
        </div>
        <img src="../../static/images/live_tu11.png" alt="" class="scenarios-box-img">
      </div>
      <div v-else-if="num == 2" class="scenarios-box">
        <div class="scenarios-box-left">
          <div class="scenarios-box-title">平台商品展示</div>
          <div class="scenarios-box-line"></div>
          <div class="scenarios-box-text">通过导购场景化地展现商品购买信息，增加用户对导购人员及商品的信任程度，尤其适用一些海外代购和美妆类的电商平台。</div>
          <div class="scenarios-box-btn">立即体验</div>
        </div>
        <img src="../../static/images/live_tu22.png" alt="" class="scenarios-box-img">
      </div>
      <div v-else-if="num == 3" class="scenarios-box">
        <div class="scenarios-box-left">
          <div class="scenarios-box-title">新品发布直播</div>
          <div class="scenarios-box-line"></div>
          <div class="scenarios-box-text">当平台有新品上市时，可用明星或网红作为噱头，吸引大流量用户关注新产品相关信息，通过名人效应增加新产品快速销售。</div>
          <div class="scenarios-box-btn">立即体验</div>
        </div>
        <img src="../../static/images/live_tu33.png" alt="" class="scenarios-box-img">
      </div>
      <div v-else class="scenarios-box">
        <div class="scenarios-box-left">
          <div class="scenarios-box-title">网红主播开店</div>
          <div class="scenarios-box-line"></div>
          <div class="scenarios-box-text">各类服装类、美妆类、网络红人博主等均可在原有直播平台上开设自己的主播分店，将大量观看流量在线转化为商品销售。</div>
          <div class="scenarios-box-btn">立即体验</div>
        </div>
        <img src="../../static/images/live_tu44.png" alt="" class="scenarios-box-img">
      </div>
      <div class="bag-box"></div>
    </div>
    <!-- 直播短视频 -->
    <div class="shopping-system">
      <div class="core-title">直播短视频购物系统能为您带来什么？</div>
      <div class="core-line"></div>
      <div class="core-text">畅享盈利新模式，提高营销转化率</div>
      <img src="../../static/images/tu3.png" alt="" class="shopping-system-img">
    </div>
    <!-- 咨询 -->
    <!-- <div class="consulting-service">
      <div class="consulting-service-text">让营销从此变得多姿多彩，现在咨询更多优惠!</div>
      <div class="consulting-service-btn">立即咨询</div>
    </div> -->
  </div>
</template>

<script>
export default {
  data(){
    return{
      num: 1
    }
  },
  methods:{
    active: function (index) {
      this.num = index;
    },
  }
}
</script>

<style scoped>
.live-commerce {
  margin-top: 60px;
}
.industry {
  margin-bottom: 80px;
  text-align: center;
}
.wholesale-mall-core {
  text-align: center;
}
.application-scenarios {
  position: relative;
  text-align: center;
  margin: 80px 0;
}
.shopping-system {
  text-align: center;
  margin: 160px 0 20px 0;
}
.industry-title,
.core-title {
  font-size: 30px;
  font-weight: bold;
  color: #333333;
}
.industry-text,
.core-text {
  font-size: 16px;
  color: #333333;
}
.industry-line,
.core-line {
  width: 42px;
  height: 2px;
  margin: 24px auto;
  background: #f5ba1a;
  border-radius: 1px;
}
.industry-box {
  margin-top: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.public-img {
  margin-right: 60px;
  width: 58px;
  height: 58px;
}
.industry-box-left-public {
  width: 700px;
  height: 160px;
  display: flex;
  border-right: 1px solid #eeeeee;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #eeeeee;
}
.public-title {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
}
.public-text {
  margin-top: 20px;
  width: 456px;
  font-size: 14px;
  text-align: left;
  font-weight: 300;
  color: #666666;
}
.industry-box-left-public:last-child {
  border-bottom: none;
}
.industry-box-left-public:hover {
  border: none;
  box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
}
.core-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 59px;
}
.supply {
  margin-left: 24px;
  padding: 48px;
  width: 322px;
  height: 328px;
  background: #ffffff;
  box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
  border-radius: 4px;
  transition: all .5s;
}
.supply:hover{
  transform: scale(1.1,1.1);
}
.supply-top {
  width: 80px;
  height: 80px;
  margin: 0 auto;
}
.supply-img {
  width: 80px;
  height: 80px;
}
.supply-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin: 13px 0 40px 0;
}
.supply-text {
  text-align: center;
  line-height: 28px;
  font-size: 14px;
  color: #666666;
}
.scenarios-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 40px 0 60px 0;
}
.scenarios-tab div {
  width: 164px;
  height: 46px;
  text-align: center;
  line-height: 46px;
  color: #333;
  font-size: 16px;
  cursor: pointer;
}
.scenarios-tab .current {
  font-size: 16px;
  background: #ffc000;
  color: #fff;
  border-radius: 23px;
}
.scenarios-box {
  position: relative;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1060px;
  height: 416px;
  background: #ffffff;
  box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
  border-radius: 8px;
}
.scenarios-box-title {
font-size: 24px;
font-weight: bold;
color: #333333;
text-align: left;
}
.scenarios-box-line {
  margin-top: 12px;
  width: 40px;
height: 4px;
background: #FFC000;
}
.scenarios-box-text{
  text-align: left;
  width: 340px;
  margin: 39px 0 68px 0;
font-size: 14px;
line-height: 24px;
color: #333333;
}
.scenarios-box-btn{
  width: 120px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #333333;
  background: #FFC000;
  border: 1px solid #FFC000;
  border-radius: 4px;
  cursor: pointer;
}
.scenarios-box-img {
  width: 380px;
  height: 280px;
  margin-left: 162px;
}
.bag-box {
  position: absolute;
  top: 430px;
  left: 50%;
  transform: translateX(-50%);
  width: 1400px;
height: 308px;
background: #F5F5F5;
}
.shopping-system-img {
  margin-top: 40px;
  width: 1920px;
  height: 600px;
}
.consulting-service {
  border-top: 1px solid #FFC000;
  width: 1920px;
  height: 160px;
  text-align: center;
background: linear-gradient(-90deg, #FFC000, #F5B400);
}
.consulting-service-text{
  margin: 31px 0 25px 0;
font-size: 24px;
color: #FFFFFF;
}
.consulting-service-btn{
  margin: 0 auto;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  font-weight: bold;
font-size: 18px;
  width: 170px;
height: 50px;
border: 1px solid #FFFFFF;
border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/pc/solutionLiveCommerce.vue